import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Facebook, MapPin } from 'lucide-react';

// Unified Website Footer Component
export default function WebsiteFooter() {
  const linkedInUrl = "https://www.linkedin.com/company/aurous-consultancy";
  
  return (
    <footer className="bg-slate-950 pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Affiliations Section */}
        <div className="mb-12 pb-8 border-b border-slate-800">
          <p className="text-sm text-slate-500 text-center mb-6">Proudly Affiliated With</p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
            {/* Malaysia Digital Logo */}
            <a 
              href="https://mdec.my/digital-economy-initiatives/for-the-industry/malaysia-digital/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group"
            >
              <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-slate-900/50 border border-slate-800 hover:border-blue-500/50 transition-all">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center">
                  <span className="text-white font-bold text-lg">MD</span>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">Malaysia Digital</p>
                  <p className="text-slate-400 text-xs">Certified Company</p>
                </div>
              </div>
            </a>
            
            {/* Ministry of Finance Malaysia Logo */}
            <a 
              href="https://www.mof.gov.my/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group"
            >
              <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-slate-900/50 border border-slate-800 hover:border-yellow-500/50 transition-all">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-yellow-500 to-amber-600 flex items-center justify-center">
                  <span className="text-white font-bold text-sm">MOF</span>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">Ministry of Finance</p>
                  <p className="text-slate-400 text-xs">Malaysia Registered</p>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-16">
          <div className="lg:col-span-1">
            <Link to="/" onClick={() => window.scrollTo(0, 0)} className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_aurous-ecosystem/artifacts/x28qd6xo_30882183-9DD0-40B4-98FF-3BB81A460020.png" 
                alt="Aurous" 
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm mb-6 leading-relaxed">
              AI-powered IT teams and delivery partner. Helping organizations scale engineering capacity with AI-enabled practices across Malaysia, Singapore, India & Hong Kong.
            </p>
            
            <div className="flex gap-3">
              <a href={linkedInUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center hover:bg-[#0A66C2] transition-colors">
                <Linkedin className="w-5 h-5 text-slate-400 hover:text-white" />
              </a>
              <a href="https://twitter.com/aurousconsult" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Twitter className="w-5 h-5 text-slate-400" />
              </a>
              <a href="https://facebook.com/aurousconsultancy" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Facebook className="w-5 h-5 text-slate-400" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">IT Solutions</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li><a href="#it-solutions" className="hover:text-white transition-colors">Product Development</a></li>
              <li><a href="#it-solutions" className="hover:text-white transition-colors">System Enhancements</a></li>
              <li><a href="#it-solutions" className="hover:text-white transition-colors">Technology Consulting</a></li>
              <li><a href="#it-solutions" className="hover:text-white transition-colors">Data Analytics & BI</a></li>
              <li><a href="#it-solutions" className="hover:text-white transition-colors">Cloud Infrastructure</a></li>
              <li><a href="#it-solutions" className="hover:text-white transition-colors">Quality Assurance</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">AI Services</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li><Link to="/services/ai-staffing" className="hover:text-white transition-colors">AI-Powered Contract Engineers</Link></li>
              <li><Link to="/services/managed-teams" className="hover:text-white transition-colors">Managed Delivery Teams</Link></li>
              <li><Link to="/services/ai-integration" className="hover:text-white transition-colors">AI & Data Engineering</Link></li>
              <li><Link to="/services/ai-governance" className="hover:text-white transition-colors">Compliance & Governance</Link></li>
              <li><Link to="/ai-talent" className="hover:text-white transition-colors">AI Talent Pool</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li><Link to="/our-work" className="hover:text-white transition-colors">Case Studies</Link></li>
              <li><Link to="/clients" className="hover:text-white transition-colors">Our Clients</Link></li>
              <li><Link to="/ai-talent" className="hover:text-white transition-colors">AI Talent Pool</Link></li>
              <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/ai-news" className="hover:text-white transition-colors">AI News</Link></li>
              <li><Link to="/blogs" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Client Login</Link></li>
              <li><Link to="/sales-deck" className="hover:text-cyan-400 transition-colors flex items-center gap-2">
                <span>Capability Deck</span>
                <span className="text-[10px] px-1.5 py-0.5 bg-cyan-500/20 text-cyan-400 rounded">NEW</span>
              </Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Policies</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li><Link to="/policy/anti-corruption" className="hover:text-white transition-colors">Anti-Corruption Policy</Link></li>
              <li><Link to="/policy/whistle-blowing" className="hover:text-white transition-colors">Whistle-Blowing Policy</Link></li>
              <li><Link to="/policy/sustainability" className="hover:text-white transition-colors">Sustainability Report</Link></li>
              <li><Link to="/policy/anti-slavery" className="hover:text-white transition-colors">Anti-Slavery Policy</Link></li>
              <li><Link to="/policy/pdpa" className="hover:text-white transition-colors">Data Protection Notice</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li>
                <a href="mailto:enquiry@aurousconsultancy.com" className="hover:text-white transition-colors">
                  enquiry@aurousconsultancy.com
                </a>
              </li>
              <li>
                <a href="tel:+60383220562" className="hover:text-white transition-colors">
                  +60 3-8322 0562
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Office Locations Section */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <h4 className="font-semibold text-white mb-6 text-center">Our Office Locations</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Malaysia HQ */}
            <a 
              href="https://www.google.com/maps/search/?api=1&query=LOT+4805-03-07+CBD+PERDANA+2+Jln+Perdana+Cyber+12+63000+Cyberjaya+Selangor+Malaysia"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-900/50 rounded-xl p-5 border border-slate-800 hover:border-blue-500/30 transition-colors cursor-pointer block"
            >
              <div className="flex items-center gap-2 mb-3">
                <MapPin className="w-4 h-4 text-blue-400" />
                <span className="font-semibold text-white text-sm">Malaysia (HQ)</span>
              </div>
              <p className="text-slate-400 text-xs leading-relaxed">
                LOT 4805-03-07, CBD PERDANA, 2,<br />
                Jln Perdana, Cyber 12,<br />
                63000 Cyberjaya, Selangor
              </p>
              <span className="text-blue-400 text-xs mt-2 inline-block hover:text-blue-300">
                +60 3-8322 0562
              </span>
            </a>
            
            {/* Singapore */}
            <a 
              href="https://www.google.com/maps/search/?api=1&query=20+Cecil+Street+05-03+GSH+Plaza+049705+Singapore"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-900/50 rounded-xl p-5 border border-slate-800 hover:border-blue-500/30 transition-colors cursor-pointer block"
            >
              <div className="flex items-center gap-2 mb-3">
                <MapPin className="w-4 h-4 text-green-400" />
                <span className="font-semibold text-white text-sm">Singapore</span>
              </div>
              <p className="text-slate-400 text-xs leading-relaxed">
                20 Cecil Street, #05-03<br />
                GSH Plaza - 049705<br />
                Singapore
              </p>
            </a>
            
            {/* India */}
            <a 
              href="https://www.google.com/maps/search/?api=1&query=301-302+Third+Floor+Alpha-1+Tradex+Tower-II+Greater+Noida+201308+India"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-900/50 rounded-xl p-5 border border-slate-800 hover:border-blue-500/30 transition-colors cursor-pointer block"
            >
              <div className="flex items-center gap-2 mb-3">
                <MapPin className="w-4 h-4 text-orange-400" />
                <span className="font-semibold text-white text-sm">India</span>
              </div>
              <p className="text-slate-400 text-xs leading-relaxed">
                301-302, Third Floor, Alpha-1<br />
                Tradex Tower-II, Greater Noida<br />
                G.B.Nagar (U.P.) - 201308
              </p>
              <span className="text-blue-400 text-xs mt-2 inline-block hover:text-blue-300">
                +91 120-4298191
              </span>
            </a>
            
            {/* United Kingdom */}
            <a 
              href="https://www.google.com/maps/search/?api=1&query=71-75+Shelton+Street+Covent+Garden+London+WC2H+9JQ+United+Kingdom"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-900/50 rounded-xl p-5 border border-slate-800 hover:border-blue-500/30 transition-colors cursor-pointer block"
            >
              <div className="flex items-center gap-2 mb-3">
                <MapPin className="w-4 h-4 text-purple-400" />
                <span className="font-semibold text-white text-sm">United Kingdom</span>
              </div>
              <p className="text-slate-400 text-xs leading-relaxed">
                71-75 Shelton Street<br />
                Covent Garden<br />
                London, WC2H 9JQ
              </p>
            </a>
          </div>
        </div>

        <div className="pt-8 mt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">© 2025 Aurous Consultancy. All rights reserved.</p>
          <div className="flex gap-6 text-sm text-slate-500">
            <Link to="/policy/pdpa" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/policy/anti-corruption" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
